import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import Home from '@/parts/pages/index';
import clientRoutes from './client';
import vibbrantRoutes from './vibbrant';

import e404 from '@/parts/pages/404';
import Accept from '@/parts/pages/accept';
import Terms from '@/parts/pages/terms';
import Privacy from '@/parts/pages/privacy';
import Manual from '@/parts/pages/manual';
import Faq from '@/parts/pages/faq';
import Profile from '@/parts/pages/vibbrante-profile-public';
import Freelancer from '@/parts/pages/freelancer';
import Indication from '@/parts/pages/indication';
// import Landing from '@/parts/pages/landing'

// import VibbrantTerms from "@/parts/pages/vibbrant/terms"

// EXAMPLES
import ExampleForm from '@/parts/pages/examples/form';

Vue.use(Router);

const router = new Router({
  props: {
    profile: String,
  },
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: '/client/login',
      meta: { requireAuth: false },
    },
    // { path: '/landing', name: 'landing', component: Landing },
    {
      path: '/welcome',
      name: 'welcome',
      redirect: '/client/login',
      meta: { requireAuth: false },
    },
    { path: '/faq', name: 'faq', component: Faq, meta: { requireAuth: false } },
    {
      path: '/accept',
      name: 'accept',
      component: Accept,
      meta: { requireAuth: false },
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms,
      meta: { requireAuth: false },
    },
    {
      path: '/indication',
      name: 'indication',
      component:Indication,
      meta: { requireAuth: false },
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy,
      meta: { requireAuth: false },
    },
    {
      path: '/manual',
      name: 'manual',
      component: Manual,
      meta: { requireAuth: false },
    },
    {
      path: '/profile/:id',
      name: 'profile',
      component: Profile,
      meta: { requireAuth: false },
    },
    {
      path: '/freelancer/:id',
      name: 'freelancer',
      component: Freelancer,
      meta: { requireAuth: false },
    },
    { ...clientRoutes },
    { ...vibbrantRoutes },
    {
      path: '/eform',
      name: 'form',
      component: ExampleForm,
      meta: { requireAuth: false },
    },
    {
      path: '/external-auth',
      name: 'external-auth',
      meta: { requireAuth: false },
    },
    { path: '*', component: e404, meta: { requireAuth: false } },
  ],
});

router.beforeEach((to, from, next) => {
  console.log(to.name);
  if (to.meta.requireAuth) {
    const loggedIn = store.getters.isLoggedIn;
    if (loggedIn) {
      if (store.getters.user.type === 'vibbrante') {
        if (
          !store.getters.user.accepted_term &&
          to.name !== 'accept-vibbrant'
        ) {
          next({ name: 'accept-vibbrant' });
          return;
        }
        next();
        return;
      }

      if (store.getters.user.type === 'client') {
        if (!store.getters.user.accepted_term && to.name !== 'accept-client') {
          next({ name: 'accept-client' });
          return;
        } else if (
          store.getters.user.accepted_term &&
          !store.getters.user.release_access &&
          to.name !== 'release-register'
        ) {
          next({ name: 'release-register' });
          return;
        }
        next();
        return;
      }
    }
    next({ name: 'welcome' });
  } else {
    console.log('FROM ===> ');
    console.log(to);
    if (to.name === 'external-auth') {
      console.log(to.query);
      console.log('Autenticação externa');
      const response = {
        headers: {
          client: to.query.client,
          expiry: to.query.expiry,
          uid: to.query.uid,
          'access-token': to.query['access-token'],
        },
        data: {
          data: {
            name: to.query.name,
            email: to.query.email,
            accepted_term: to.query.accepted_term,
          },
        },
      };
      const today_date = new Date();
      store.dispatch('loginVibbrante', response);
      next({ name: 'vibbrant-dashboard' });
    }
    next();
  }
  // if (to.meta.requireAuth) {
  //   if (store.getters.isLoggedIn) {
  //     if (store.getters.user.type === "vibbrante") {
  //       if(!store.getters.user.accepted_term && to.name !== "accept-vibbrant") {
  //         next({ name: "accept-vibbrant" });
  //         return
  //       }
  //     } else {
  //       if(!store.getters.user.accepted_term && to.name !== "accept-client"){
  //         next({ name: "accept-client" });
  //         return
  //       }
  //       if(!store.getters.user.release_access && to.name !== "release-register"){
  //         next({ name: "release-register" });
  //         return
  //       }
  //     }

  //     next();

  //   } else {
  //     next({ name: "welcome" });
  //   }
  // } else {
  //   if (to.name === "welcome" || to.name === "root") {
  //     if (store.getters.isLoggedIn) {
  //       if (store.getters.user.type === "vibbrante") {
  //         next({ name: "vibbrant-dashboard" });
  //       } else {
  //         next({ name: "client-dashboard" });
  //       }
  //     } else {
  //       next();
  //     }
  //   } else {
  //     next();
  //   }
  // }
});

export default router;

// if (
//   store.getters.user.type === "vibbrante" &&
//   !store.getters.user.accepted_term &&
//   to.name !== "accept-vibbrant"
// ) {
//   next({ name: "accept-vibbrant" });
// } else if (
//   store.getters.user.type === "client" &&
//   !store.getters.user.accepted_term &&
//   to.name !== "accept-client"
// ) {
//   next({ name: "accept-client" });
// } else {
//   next();
// }

// else if (
//   store.getters.user.type === "client" &&
//   !store.getters.user.release_access &&
//   to.name !== "release-register"
// ) {
//   next({ name: "release-register" });
// }



// WEBPACK FOOTER //
// ./src/router/index.js